import * as React from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from './model/reducers';
import { connect } from 'react-redux';
import LoginPage from './pages/LoginPage';
import { ThemeSettings, ThemesState } from './model/themes/types';
import ThemesAPI from './api/themes';
import { createThemes } from './model/themes/reducer';
import { setHrefData } from './model/navigation/actions';
import { HrefData } from './model/navigation/types';
import { IBaseTheme } from './settings/themes';
import { CircularProgress, Dialog } from '@mui/material';
import { ThemeProvider } from '@mui/styles';
import PortalPage from './pages/PortalPage';
import { I18nextProvider } from 'react-i18next';
import i18n from './translations';

// ----------------- State & Props -----------------  //

interface State 
{
    loaded: boolean;
    themes: ThemesState;
};

interface LocalProps {}

interface StateProps
{
    themes: ThemesState;
    hrefData: HrefData;
}

interface DispatchProps 
{
    setHrefData: typeof setHrefData;
}

type Props = LocalProps & StateProps & DispatchProps;

// -------------------- Class --------------------  //

class ThemeWrapper extends React.Component<Props, State> 
{
    // ============================================ //
    //               Member Variables               //
    // ============================================ //

    global: any;
    translation: any;
    count: number = 0;

    // ============================================ //
    //               Routine Functions              //
    // ============================================ //

    constructor(props: any)
    {
        super(props);
        
        // Init State
        this.state = {
            loaded: true,
            themes: {}
        };
    }

    // ============================================ //

    render () 
    {
        let subs = window.location.pathname.split("/");
        let login = subs[subs.length-1].includes("login");

        let theme = login && this.state.themes["default"] ?
            this.state.themes["default"] : 
            this.props.themes["default"];
        this.setupPageTheme(theme, login);

        return (<>
            <ThemeProvider<IBaseTheme> theme={theme}>
                <I18nextProvider i18n={i18n}>
                    {this.renderPage(login, theme)}
                </I18nextProvider>
            </ThemeProvider>
        </>);
    }

    // ============================================ //

    renderPage(login: boolean, theme: IBaseTheme)
    {
        return !this.state.loaded ? (
            <Dialog 
                open={true} 
                onBackdropClick={(evt)=>{evt.stopPropagation(); evt.preventDefault();}} 
                disableEscapeKeyDown 
                PaperProps={{style:{width: "100px", height: "100px"}}}
            >
                <CircularProgress style={{marginLeft: "30px", marginTop: "27px"}} />
            </Dialog>
        ) : login ? (
            <LoginPage />
        ) : (
            <PortalPage />
        )
    }

    // ============================================ //

    componentDidMount()
    {
        ThemesAPI.getThemes().then((themeSettings: ThemeSettings)=>{
            this.setState({loaded: true, themes: createThemes(themeSettings)});
        });

        window.onhashchange = () => {
            this.props.setHrefData(window.location);
        };
    }

    // ============================================ //

    componentWillUnmount() 
    {
         
    }

    // ============================================ //
    //                Setup Functions               //
    // ============================================ //

    setupPageTheme(theme: IBaseTheme, login: boolean)
    {
        // Update Page Icon to Theme
        var link = (document.querySelector("link[rel*='icon']") || document.createElement('link')) as HTMLLinkElement;
        link.rel = 'shortcut icon';
        link.href = theme.icon+"?v="+(this.count++);
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    // ============================================ //
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState, props: LocalProps): StateProps => ({
    themes: state.themes,
    hrefData: state.navigation.href
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{},{},any>, props: LocalProps): DispatchProps => ({
    setHrefData: (data: Location)=>dispatch(setHrefData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeWrapper);

// ------------------------------------------  //